import classNames from "classnames";
import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
import { Card, Col, Form, Label, Row } from "reactstrap";
import {
  BlockDes,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  ReactDataTable,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { useDataFetch } from "../../../hooks/useDataFetch";
import { toast } from "react-toastify";

const Volunteer = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const onFormSubmit = (e) => {
    createArea({ name: e.name });
  };
  const formClass = classNames({
    "form-validate": true,
  });

  const { getData, deleteData, postData, invalidateQuery } = useDataFetch();

  const { data, isLoading, refetch } = getData(
    ["volunteer-name"],
    "/panel/volunteer-name",
    { enabled: true }
  );

  const { mutate: createArea, isLoading: isPostLoading } = postData(
    "/panel/volunteer-name",
    {},
    {},
    {
      onSuccess: (data) => {
        reset();
        refreshTable();
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const { mutate: deleteArea } = deleteData(
    "/panel/volunteer-name",
    {},
    {
      onSuccess: (data) => {
        refreshTable();
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const refreshTable = async () => {
    await refetch();
    invalidateQuery(["volunteer-name"]);
  };

  const dataTableColumns2 = useMemo(
    () => [
      {
        name: "Código",
        selector: (row) => row.id,
        cell: (row) => (
          <div className="user-card mt-2 mb-2">
            <span>{row.id}</span>
          </div>
        ),
        sortable: true,
      },
      {
        name: "Nombre",
        selector: (row) => row.name,
        minWidth: "140px",
        cell: (row) => <span className="tb-amount">{row.name}</span>,
        sortable: true,
      },
      {
        name: "Acciones",
        cell: (row) => (
          <Button onClick={() => handleDelete(row.id)}>
            <Icon name="trash" size={20} />
          </Button>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ],
    [data]
  );

  const handleDelete = (id) => {
    deleteArea({ id });
  };

  return (
    <React.Fragment>
      <Head title="Voluntarios"></Head>
      <Content>
        <Card className="">
          <div className="card-aside-wrap">
            <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg p-4`}
            >
              <Form className={formClass} onSubmit={handleSubmit(onFormSubmit)}>
                <Row className="g-gs">
                  <Col md="12">
                    <BlockHeadContent>
                      <BlockTitle tag="h4">Crear Voluntarios</BlockTitle>
                      <BlockDes></BlockDes>
                    </BlockHeadContent>
                    <div className="form-group mt-4">
                      <Label className="form-label" htmlFor="fv-full-name">
                        Nombre
                      </Label>
                      <div className="form-control-wrap">
                        <input
                          type="text"
                          id="fv-full-name"
                          {...register("name", { required: true })}
                          className="form-control"
                        />
                        {errors.name && (
                          <span className="invalid">
                            Este campo es requerido
                          </span>
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col md="12">
                    <div className="form-group">
                      <Button color="primary" size="lg">
                        Guardar
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
            <div className="card-inner card-inner-lg">
              {data && !isLoading && !isPostLoading && (
                <ReactDataTable
                  data={data}
                  columns={dataTableColumns2}
                  pagination
                  className="nk-tb-list"
                  
                />
              )}
            </div>
          </div>
        </Card>
      </Content>
    </React.Fragment>
  );
};

export default Volunteer;
